import(/* webpackMode: "eager" */ "/home/aidyn/server/projects/optovichok/frontend/src/app/not-found.tsx");
